import type { ReactNode } from 'react';

export const symbol_quick_reorder: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M70-160q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-220 70-220h169v-101H110q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q97.25-381 110-381h129v-101h-83q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h83v-130l-66-156q-5-11-.5-22.5T188-867q11-5 23-1t17 16l74 174h512l-68-150q-5-11-.5-22.5T761-867q11-5 23-.5t17 15.5l74 162q2 6 3.5 12.5T880-665v445q0 24.75-17.62 42.37Q844.75-160 820-160H70Zm403-292h174q12.75 0 21.38-8.68 8.62-8.67 8.62-21.5 0-12.82-8.62-21.32-8.63-8.5-21.38-8.5H473q-12.75 0-21.37 8.68-8.63 8.67-8.63 21.5 0 12.82 8.63 21.32 8.62 8.5 21.37 8.5ZM299-220h521v-398H299v398Zm0 0v-398 398Z"
		/>
	</svg>
);
